import { arrayOf, func, number } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import withConfirm from '../../../generic/with-confirm';
import { isDiscountApplicable } from '../../../invoices/utils';
import { bookingEntryShape } from '../../../prop-types';
import { applyDiscountToMatchBudget } from '../../actions/booking-entry-actions';

const ButtonWithConfirmation = withConfirm(
  'Do you really want to apply a discount?',
)(Button);

const ApplyBudgetDiscountButton = ({ budget, entries, onClick }) => {
  return (
    <ButtonWithConfirmation
      onClick={() => onClick(budget, entries)}
      className="float-right btn-light btn-sm"
      disabled={!isDiscountApplicable(budget, entries)}
    >
      Apply discount to match budget
    </ButtonWithConfirmation>
  );
};

ApplyBudgetDiscountButton.propTypes = {
  budget: number.isRequired,
  entries: arrayOf(bookingEntryShape.isRequired).isRequired,
  onClick: func.isRequired,
};

const mapDispatchToProps = {
  onClick: applyDiscountToMatchBudget,
};

export default connect(null, mapDispatchToProps)(ApplyBudgetDiscountButton);
